<div class="mt-5 d-flex justify-content-center" *ngIf="loading">
  <div>
    <img class="mb-4 logo logo-themed" alt="Bitwarden" />
    <p class="text-center">
      <i
        class="bwi bwi-spinner bwi-spin bwi-2x text-muted"
        title="{{ 'loading' | i18n }}"
        aria-hidden="true"
      ></i>
      <span class="sr-only">{{ "loading" | i18n }}</span>
    </p>
  </div>
</div>
<div class="container" *ngIf="!loading && !authed">
  <div class="row justify-content-md-center mt-5">
    <div class="col-5">
      <p class="lead text-center mb-4">{{ "setupProvider" | i18n }}</p>
      <div class="card d-block">
        <div class="card-body">
          <p>{{ "setupProviderLoginDesc" | i18n }}</p>
          <hr />
          <div class="d-flex">
            <a routerLink="/" [queryParams]="{ email: email }" class="btn btn-primary btn-block">
              {{ "logIn" | i18n }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
